module.exports = __webpack_public_path__ + "static/media/my-vinos-winelists.8aa3be9a.jpg";